import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type MessageModel from 'scaleflow/models/message';

export interface ChatErrorMessageSignature {
  // The arguments accepted by the component
  Args: {
    message: MessageModel;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class ChatErrorMessage extends Component<ChatErrorMessageSignature> {
  @tracked element: HTMLElement | undefined = undefined;

  @action
  setMarkdownElement(element: HTMLElement) {
    this.element = element;
  }
}
